module.exports = __webpack_public_path__ + "static/media/7.4a561311.png";